import { queryKeys } from 'config/queryKeys'
import { routes } from 'config/routes'
import { useTranslation } from 'libs/i18n'
import { useMutation, useQueryClient } from 'libs/query'
import { useNavigate, useParams } from 'libs/router'

import { useAxiosPrivate, useToast } from 'shared/hooks'
import type { AreaPayload } from 'features/areas/types/areas.types'

export const useEditAreaMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const navigate = useNavigate()
	const params = useParams()
	const queryClient = useQueryClient()

	const { mutate: editAreaMutation, isPending: loadingEditArea } = useMutation({
		mutationFn: (data: AreaPayload) => {
			// TODO: change to apiRoutes
			return axiosPrivate.patch(`/booths/${params.id}/`, data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.booths.all })
			useToast({ type: 'success', message: t('Area updated') })()

			navigate(routes.areaIndex)
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editAreaMutation,
		loadingEditArea
	}
}
